import Transformer from "@/transformers/transformer";

import moment from "moment";
moment.locale("es-mx");

const supplyTransformer = function ({
  iwarehouse_requisition_supply_id: iwarehouseRequisitionSupplyId,
  quantity,
  consolidated_status: consolidatedStatus,
  supply_id: supplyId,
  supply_name: supplyName,
  supply_unit_measurement_abbr: supplyUnitAbbr,
  supply_unit_measurement_name: supplyUnitName,
  current_stock: currentStock,
  max_existence: maxExistence,
  max_quantity: maxQuantity,
  rejected,
  supply_code: supplyCode,
}) {
  return {
    supplyName,
    supplyId,
    consolidatedStatus,
    quantity: Number.parseFloat(quantity).toFixed(6),
    iwarehouseRequisitionSupplyId,
    supplyUnitAbbr,
    supplyUnitName,
    currentStock,
    maxExistence,
    maxQuantity,
    rejected,
    supplyCode,
  };
};

export default class requisitionsTransformer extends Transformer {
  static fetch({
    status,
    iwarehouse_requisition_id: requisitionId,
    folio,
    type_of_requisition: typeRequisition,
    iwarehouse_requisition_supplies: supplies,
    added_date: addedDate,
    highway,
    applicant,
    related_sinisters: related,
    consolidated_status: consolidatedStatus,
    date_authorization_quotation: dateAuthorizationQuotation,
    date_release: dateRelease,
  }) {
    const relatedSinisters = related.length > 0
          ? related.map((s) => ({
              id: s.sinister_id,
              number: s.sinister_number,
              requisitionNumber: s.requisition_number,
            }))
          : []
    
    const requisitionSupplies = supplies.length > 0 ? supplies.map((s, index) => ({...supplyTransformer(s), index})) : []
    return {
      consolidatedStatus,
      status,
      requisitionId,
      folio,
      typeRequisition: typeRequisition === "material_extra" ? "Extra" : typeRequisition,
      highway,
      applicant,
      relatedSinisters,
      dateAuthorizationQuotation: dateAuthorizationQuotation && moment(dateAuthorizationQuotation).format("DD/MM/YYYY"), 
      dateRelease: dateRelease && moment(dateRelease).format("DD/MM/YYYY"),
      requisitionSupplies,
      addedDate: moment(addedDate).format("DD/MM/YYYY"),
      addDate: moment(addedDate).format("YYYY-MM-DD"),
    };
  }
}



// WEBPACK FOOTER //
// ./src/transformers/catalog/warehouse/requisitions.js